<div class="bpx-dialog bpx-dialog--wide discard-warning-dialog">
  <h2 mat-dialog-title>Run Quality Warning</h2>

  <mat-dialog-content>
    <p class="discard-warning-dialog__intro">
      This run contains at least 10% discarded replicates or true instrument errors.
    </p>

    @if (data.discardBreaches.length) {
      <h3 class="bpx-section__title discard-warning-dialog__section-title">Discarded Replicates</h3>
      <p class="discard-warning-dialog__total">
        <strong>{{ data.totalDiscarded }}</strong> of <strong>{{ data.totalAnalyzed }}</strong>
        replicates analyzed were discarded
        (<strong>{{ asPercent(data.totalDiscardedFraction) }}</strong> of the study).
      </p>
      <p class="discard-warning-dialog__caption">
        More than 10% of replicates were discarded for the following:
      </p>
      <table class="bpx-grid-card discard-warning-dialog__table">
        <thead>
          <tr>
            <th scope="col">Kit Lot</th>
            <th scope="col">Instrument</th>
            <th scope="col">Bead Region</th>
            <th scope="col">Discarded</th>
            <th scope="col">Analyzed</th>
            <th scope="col">Percent</th>
          </tr>
        </thead>
        <tbody>
          @for (breach of data.discardBreaches; track breach.reportContentItemId) {
            <tr>
              <td>{{ breach.kitLot }}</td>
              <td>{{ breach.instrumentId }}</td>
              <td>{{ breach.beadRegion }}</td>
              <td>{{ breach.discardedCount }}</td>
              <td>{{ breach.analyzedCount }}</td>
              <td>{{ asPercent(breach.discardedFraction) }}</td>
            </tr>
          }
        </tbody>
      </table>
    }

    @if (data.instrumentBreaches.length) {
      <h3 class="bpx-section__title discard-warning-dialog__section-title">Instrument True Errors</h3>
      <p class="discard-warning-dialog__caption">
        The following instruments reported a true error rate above 10%:
      </p>
      <table class="bpx-grid-card discard-warning-dialog__table">
        <thead>
          <tr>
            <th scope="col">Instrument ID</th>
            <th scope="col">Percent True Errors</th>
          </tr>
        </thead>
        <tbody>
          @for (breach of data.instrumentBreaches; track breach.instrumentId) {
            <tr>
              <td>{{ breach.instrumentId }}</td>
              <td>{{ asPercent(breach.percentTrueErrors) }}</td>
            </tr>
          }
        </tbody>
      </table>
    }

  </mat-dialog-content>

  <mat-dialog-actions>
    <button matRipple class="bpx-btn bpx-btn--primary" (click)="close()">OK</button>
  </mat-dialog-actions>
</div>
